import Auth from '../views/authentication/Auth.jsx';
import RecoverPassword from '../views/authentication/RecoverPassword';
import ResetPassword from '../views/authentication/ResetPassword';
import Verify from '../views/authentication/verify.jsx';
import Privacy from '../views/pages/PrivacyAndTerms/Privacy';
import Terms from '../views/pages/PrivacyAndTerms/Terms';
import SetPassword from '../views/pages/SetPassword';

const authRoutes = [
  {
    path: '/auth/login',
    name: 'Sign in to Kraal',
    icon: 'mdi mdi-account-key',
    component: Auth
  },
  {
    path: '/auth/register',
    name: 'Register',
    icon: 'mdi mdi-account-plus',
    component: Auth
  },
  {
    path: '/auth/terms',
    name: 'terms',
    icon: 'mdi mdi-account-plus',
    component: Terms
  },
  {
    path: '/auth/privacy',
    name: 'terms',
    icon: 'mdi mdi-account-plus',
    component: Privacy
  },
  {
    path: '/auth/recover-pwd',
    name: 'Recover Password',
    icon: 'mdi mdi-account-convert',
    component: RecoverPassword
  },
  {
    path: '/account/verify/:token',
    name: 'verify',
    icon: 'mdi mdi-pencil-box-outline',
    component: Verify
  },
  {
    path: '/account/password-reset/:token',
    name: 'reset',
    icon: 'mdi mdi-pencil-box-outline',
    component: ResetPassword
  },
  {
    path: '/account/password-set/:token',
    name: 'set',
    icon: 'mdi mdi-pencil-box-outline',
    component: SetPassword
  }
];
export default authRoutes;
